import React, {Component} from 'react';
import classnames from 'classnames';

class FilterHeader extends Component {
  handleClick = () => {
    const {onToggleFilters} = this.props;
    onToggleFilters();
  };

  selectedFiltersText = () => {
    const filterCount = this.countFilters();

    if (filterCount === 0) {
      return 'no filters selected';
    } else if (filterCount === 1) {
      return '1 filter selected';
    }
    return `${filterCount} filters selected`;
  };

  countFilters = () => {
    const {filterBox} = this.props;
    let filterCount = 0;
    filterCount += filterBox.categories.length;
    filterCount += filterBox.brands.length;
    filterCount += filterBox.specialStockIt ? 1 : 0;
    filterCount += filterBox.specialPriceIt ? 1 : 0;
    filterCount += filterBox.specialSellIt ? 1 : 0;
    filterCount += filterBox.selectedOutlet ? 1 : 0;
    filterCount += filterBox.specialNew ? 1 : 0;

    return filterCount;
  };

  render() {
    const {filterBox, fetchingProducts} = this.props;
    return (
      <div
        className={classnames('filter-dropdown', {opened: true})}
        onClick={this.handleClick}
      >
        <h2>
          { fetchingProducts ? 'Products Loading...' : 'Filters' }
          <span className="filter-count">{this.selectedFiltersText()}</span>
          { (filterBox.showFilters) && (<i className="fa fa-angle-up"/>) }
          { (!filterBox.showFilters) && (<i className="fa fa-angle-down"/>) }
        </h2>
      </div>
    );
  }
}

export default FilterHeader;



// WEBPACK FOOTER //
// ./src/components/product-page/filters/filter-header.jsx